import React from 'react';
import './SearchBar.css';

const SearchBar = (props) => (
    <div className="SearchBarWrapper">
        {props.children}
    </div>
);

export default SearchBar;
